import * as React from 'react'
import { graphql } from 'gatsby'
import Layout from "../components/layout"
import Seo from "../components/seo"
import Navbar from '../components/navbar'
import ReactMarkdown from 'react-markdown'
import Bio from "../components/bio"

const GratitudeIndex = ({data, location}) => {
  const siteTitle = data.site.siteMetadata?.title || `Title`

  const gratitudeContent = `
  > "Enjoy the little things, for one day you may look back and realize they were the big things."
  >
  >  Robert Brault

  ### August

  1. Although my job is primarily remote, I had an opportunity to work in office and get to know my co-workers.
  2. Finished my final month for my co-op term and it was such a great experience.
  3. In the final week of August, I went with my family for a week long vacation in Los Cabos, Mexico and it was one of the best vacations I've ever had. 
  4. Started actively practicing Tagalog which is the official language of the Philippines. 
  5. Packed up all my things and was ready to move to Waterloo.

  ### July

  1. Celebrated my cousin's wedding! 
  2. Did the #Gentleminions trend with my cousins where everyone wore a suit to watch the Minions movie.  
  3. Also ate a fantastic ramen place with my cousins after the movie was over.
  4. Went to Quebec with my family for another fun vacation.
  5. Started using a voice journal which is really useful for helping me process my thoughts and self reflection.

  ### June

  1. Celebrated my Mom's birthday!
  2. Helped my cousin and younger brother film another music video.
  3. Attended the Power to Change club camp retreat called Recharge and it was so good.
  4. My Aunt treated my brothers and I to bubble tea.
  5. My Grandma made it back home safely from her 4 month vacation in the Phillipines. 

  ### May

  1. Started my new job as a Software Developer and I loved it so much.
  2. Started taking driving lessons with my Dad.
  3. Created a habits productivity plan with all my cousins and they all really enjoy it.
  4. Found and used an amazing website that allows you to write letters to your future self.
  5. Went to Muskoka with my family for the long weekend, a super memorable experience. 

  ### April 

  1. Found someone to sublet my place so I saved a lot of money.
  2. Attended the Power to Change Banquet, which is the final club event for the semester. 
  3. Finished all my exams for the semester!
  4. My parents came to Waterloo to help me move all my belongings.
  5. My family got a cat and it was the first time we ever had a pet.

  ### March

  1. Attended my cousin's 19th birthday and it was a blast. 
  2. Participated in a social scavenger hunt where we took fun and unique photos.
  3. Wrote a shared journal with friends to celebrate what we were able to accomplish during the pandemic.
  4. Started group studying with friends on a much more consistent basis.
  5. Got an offer for my first CS job!

  ### February

  1. My roommate hosted a small dinner party which was lots of fun and it gave me an opportunity to get to know everyone there.
  2. Got to study with my friends on campus for the first time since the pandemic.
  3. For Family Day, we cooked an amazing breakfast together!
  4. Bought a new card game that I'm really excited about.
  5. Had a monthly hangout call with my online friends.

  ### January

  1. Got to have an amazing discussion with my family where we reflected on how 2021 has been and want we want do moving forward in 2022!
  2. Finished reading "Think Like a Monk" and it gave amazing insights and an interspective on how to live life.
  3. Started sharing my Google Calendar to my friend for increased accoutability.
  4. Helped my cousin and younger brother film a music video.
  5. Enjoyed grocery shopping with my parents.

  ---

  
  `;

  return (
    <Layout location={location} title={siteTitle}>
        <Seo title="Gratitude" />
        <Navbar></Navbar>
        <ReactMarkdown>{gratitudeContent}</ReactMarkdown> 
        <Bio />    
    </Layout>
  )
}

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      nodes {
        excerpt
        fields {
          slug
        }
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          title
          description
          category
        }
      }
    }
  }
`

export default GratitudeIndex